import React, { useState } from 'react';
import { AppProvider, useAppData } from './context/AppContext';
import Layout from './components/Layout';
import WatchlistView from './components/Watchlist/WatchlistView';
import PlannerView from './components/Planner/PlannerView';
import AdminDashboard from './components/Admin/AdminDashboard';
import AuthScreen from './components/Auth/AuthScreen';
import * as FiIcons from 'react-icons/fi';

function AppContent() {
  const { session, loading } = useAppData();
  const [activeView, setActiveView] = useState('watchlists');

  if (!session) {
    return <AuthScreen />;
  }

  if (loading) {
    return (
      <div className="h-screen w-screen bg-app-bg flex flex-col items-center justify-center text-app-accent">
        <FiIcons.FiLoader className="animate-spin text-4xl mb-4" />
        <p className="font-mono text-sm uppercase tracking-widest">Synchronizing Terminal...</p>
      </div>
    );
  }

  const renderView = () => {
    switch (activeView) {
      case 'watchlists': return <WatchlistView />;
      case 'planner': return <PlannerView />;
      case 'admin': return <AdminDashboard />;
      default: return <WatchlistView />;
    }
  };

  return (
    <Layout activeView={activeView} setActiveView={setActiveView}>
      {renderView()}
    </Layout>
  );
}

export default function App() {
  return (
    <AppProvider>
      <AppContent />
    </AppProvider>
  );
}